import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { IEmailComposeRightPanelProps } from "./EmailCompose.types";
import { EmailOutlined, ContentCopy, Check } from "@mui/icons-material";
import { EmailComposeDialog } from "./EmailComposeDialog";


const CopyWithAnimation: React.FC<{ value: string }> = ({ value }) => {
  const [copied, setCopied] = React.useState(false);
  const [rotating, setRotating] = React.useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setRotating(true);
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
    setTimeout(() => {
      setCopied(false);
      setRotating(false);
    }, 2000);
  };

  return (
    <IconButton
      size="small"
      onClick={handleCopy}
      sx={{
        ml: 1,
        transition: "transform 0.4s",
        transform: rotating ? "rotate(360deg)" : "none",
      }}
      aria-label={copied ? "Copied" : "Copy"}
    >
      {copied ? (
        <Check color="success" fontSize="small" />
      ) : (
        <ContentCopy color="action" fontSize="small" />
      )}
    </IconButton>
  );
};

export const EmailComposeRightPanel: React.FC<IEmailComposeRightPanelProps> = (
  props
) => {
  const { toEmail, displayLabel, id, rowData, objectVariableKey } = props;
  const [open, setOpen] = React.useState(false);

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      <Box display={"flex"} alignItems="center">
        <Box
          display="flex"
          alignItems="center"
          sx={{ cursor: "pointer" }}
          onClick={handleToggleOpen}
        >
          <EmailOutlined color="primary" fontSize="small" />
          <Typography variant="body1" marginLeft={1}>
            {displayLabel}
          </Typography>
        </Box>
        <CopyWithAnimation value={displayLabel || ""} />
      </Box>
      {open && (
        <EmailComposeDialog
          open={open}
          id={id}
          onClose={handleToggleOpen}
          {...props}
          variableKey={objectVariableKey}
          rowData={rowData}
        />
      )}
    </>
  );
};
